/* eslint-disable react/jsx-pascal-case */
// src/components/Dashboard.jsx
import React, { useState } from "react";
import "../dash.css";
import logo from "../assets/logo/logo.png"; // adjust path if needed
import { Personal_info_fields } from "./components/personal-info-fields";
import { Kin_or_Relative_info } from "./components/kin-or-relative-info";
import { Sponser_info } from "./components/sponser-info";
import { ApplicationStatusBoard } from "./components/status";
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState as useReactState } from 'react';
import { Academic_info_fields } from "./components/academic-info-fields";
import { Preview } from "./components/preview";
import CourseSelection from "./components/course-selection";
import { UserProvider, useUser } from "../UserContext";
import { auth } from '../firebase';

function DashboardContent() {
  const personalbar = "personal-info";
  const kinbar = "kin-or-relative-info";
  const sponserbar = "sponser-info";
  const academicbar = "academic-info";
  const statusbar = "status";
  const previewbar = "preview";
  const coursebar = "course-selection";
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [tab, setTab] = useState("");
  const tabBgColor = "darkblue";
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useUser();

  // Handle body scroll when sidebar is open on mobile
  useEffect(() => {
    if (sidebarOpen) {
      document.body.classList.add('sidebar-open');
    } else {
      document.body.classList.remove('sidebar-open');
    }
    
    return () => {
      document.body.classList.remove('sidebar-open');
    };
  }, [sidebarOpen]);

  useEffect(() => {
    if (!loading && !user) {
      navigate('/login');
    }
  }, [user, loading, navigate]);

  // Handle URL parameters for tab navigation
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam) {
      setTab(tabParam);
    }
  }, [location.search]);

  const handleLogout = async () => {
    await auth.signOut();
    navigate('/login');
  };

  const goToNextAfterPersonal = () => setTab(kinbar);
  const goToNextAfterKin = () => setTab(sponserbar);
  const goToNextAfterSponser = () => setTab(academicbar);
  const goToNextAfterAcademic = () => setTab(coursebar);

  const swichtab = (tab) => {
    switch (tab) {
      case "personal-info":
        return <Personal_info_fields onSuccess={goToNextAfterPersonal} />;
      case "kin-or-relative-info":
        return <Kin_or_Relative_info onSuccess={goToNextAfterKin} />;
      case "academic-info":
        return <Academic_info_fields onSuccess={goToNextAfterAcademic} />;
      case "status":
        return <ApplicationStatusBoard />;
      case "sponser-info":
        return <Sponser_info onSuccess={goToNextAfterSponser} />;
      case "course-selection":
        return <CourseSelection />;
      case "preview":
        return <Preview />;
      default:
        return <ApplicationStatusBoard />;
    }
  }

  if (loading) return <div className="loader"></div>;

  return (
    <div className="dashboard">
      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <a href="/" style={{textDecoration: 'none', color: 'inherit'}}>
            <h2>BACK</h2>
          </a>
        </div> 
        <div className="sidebar-content">
          <div className="sidebar-navigation">
            <ul>
              <li className="title">📝 APPLICATION</li>
              <li onClick={() => setTab(personalbar)} style={{ backgroundColor: tab === personalbar ? tabBgColor : "inherit" }}>
                👤 Personal Information
              </li>
              <li onClick={() => setTab(kinbar)} style={{ backgroundColor: tab === kinbar ? tabBgColor : "inherit" }}>
                👨‍👩‍👧‍👦 Kin/Relative Information
              </li>
              <li onClick={() => setTab(sponserbar)} style={{ backgroundColor: tab === sponserbar ? tabBgColor : "inherit" }}>
                💰 Financial Supporter Information
              </li>
              <li onClick={() => setTab(academicbar)} style={{ backgroundColor: tab === academicbar ? tabBgColor : "inherit" }}>
                🎓 Academic Information
              </li>
              <li onClick={() => setTab(coursebar)} style={{ backgroundColor: tab === coursebar ? tabBgColor : "inherit" }}>
                📚 Course Selection
              </li>
              <li onClick={() => setTab(previewbar)} style={{ backgroundColor: tab === previewbar ? tabBgColor : "inherit" }}>
                👁️ Preview and Submit
              </li>
              <li className="title">📊 APPLICATION STATUS</li>
              <li onClick={() => setTab(statusbar)} style={{ backgroundColor: tab === statusbar ? tabBgColor : "inherit" }}>
                📈 Status
              </li>
            </ul>

             {/* User Info and Logout in Sidebar - shown on mobile */}
          {user && (
            <div className="sidebar-user-info" style={{ 
              // marginTop: 'auto', 
              // padding: '20px', 
              borderTop: '1px solid #e0e0e0',
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              gap: 12,
            }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 8,
                marginBottom: 8
              }}>
                <div style={{ 
                  width: 36, 
                  height: 36, 
                  borderRadius: '50%', 
                  background: '#007bff', 
                  color: '#fff', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  fontWeight: 700, 
                  fontSize: 18 
                }}>
                  {user.email ? user.email[0].toUpperCase() : '?'}
                </div>
                <span style={{ 
                  fontWeight: 500, 
                  fontSize: '14px',
                  color: 'white'

                }}>
                  {user.email}
                </span>
              </div>
              <button 
                onClick={handleLogout} 
                style={{
                  padding: '8px 16px', 
                  borderRadius: 6, 
                  background: '#fff', 
                  color: '#007bff', 
                  border: '1px solid #007bff', 
                  fontWeight: 600, 
                  cursor: 'pointer',
                  fontSize: '14px',
                  width: '100%'
                }}
              >
                Logout
              </button>
            </div>
          )}
          </div>
        </div>
      </div>

      {/* Overlay */}
      {sidebarOpen && (
        <div className="overlay" onClick={() => setSidebarOpen(false)}></div>
      )}

      {/* Main Content */}
      <div className="main" >
        {/* Header with Logo and Title */}
        <header className="top-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <center style={{ flex: 1 }}><h1 className="system-title">ARTHUR APPLICATION SYSTEM (AAS)</h1></center>
          {/* User Info and Logout in Header  */}
          <div className="header-user-info"  style={{ display: 'flex', alignItems: 'center', gap: 16, marginRight: 16 }} >
            {user && (
              <>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} >
                  <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#007bff', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 18 }}>
                    {user.email ? user.email[0].toUpperCase() : '?'}
                  </div>
                  <span style={{ fontWeight: 500 }}>{user.email}</span>
                </div>
                <button onClick={handleLogout} style={{ marginLeft: 12, padding: '6px 14px', borderRadius: 6, background: '#fff', color: '#007bff', border: '1px solid #007bff', fontWeight: 600, cursor: 'pointer' }}>Logout</button>
              </>
            )}
          </div>
          <button
            className="toggle-btn"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            ☰
          </button>
        </header>

        {/* tabs */}
        {swichtab(tab)}

        {/* Footer */}
        {/* <footer className="dashboard-footer">
          <p>© 2025 Arthur International Agency (AIA). All rights reserved.</p>
        </footer> */}
      </div>
    </div>
  );
}



export default function Dashboard() {
  return (
    <UserProvider>
      <DashboardContent />
    </UserProvider>
  );
}

